<template>
  <v-container class="modern-pvsa-container" fluid ma-0 pa-0>
    <!-- Modern Header -->
    <div class="modern-pvsa-header">
      <div class="header-background">
        <div class="header-circle header-circle-1"></div>
        <div class="header-circle header-circle-2"></div>
        <div class="header-circle header-circle-3"></div>
      </div>
      <div class="header-content-wrapper">
        <div class="header-icon-wrapper">
          <v-icon size="56" color="white">mdi-medal</v-icon>
        </div>
        <div class="header-text-content">
          <h1 class="modern-pvsa-title">President's Volunteer Service Award</h1>
          <p class="modern-pvsa-subtitle">
            <v-icon small color="white" class="mr-1">mdi-hand-heart</v-icon>
            Recognizing Excellence in Volunteer Service
          </p>
        </div>
      </div>
    </div>

    <v-row class="ma-0 px-4 py-6" justify="center">
      <v-col cols="12" md="11" lg="10">
        <!-- Hero Card with PVSA Logo -->
        <v-card class="modern-hero-card mb-6" elevation="0">
          <v-row class="ma-0" align="center">
            <v-col cols="12" md="7" class="pa-6">
              <div class="hero-content">
                <div class="hero-badge">
                  <v-icon small color="white" class="mr-1">mdi-certificate</v-icon>
                  <span>Certified Organization Since 2021</span>
                </div>
                <h2 class="hero-title">The President's Volunteer Service Award</h2>
                <p class="hero-description">
                  Charlotte Tamil Sangam a.k.a The Greater Charlotte Tamil Association works with its Members,
                  Leaders and other like minded Organizations to serve the need of Community in Language, Cultural
                  and Social Welfare front. We promote Volunteerism among Youths and empower them to become
                  successful servant leaders.
                </p>
                <div class="hero-features">
                  <div class="feature-item">
                    <v-icon color="#667eea" class="mr-2">mdi-check-circle</v-icon>
                    <span>Volunteering Opportunities for Members</span>
                  </div>
                  <div class="feature-item">
                    <v-icon color="#667eea" class="mr-2">mdi-check-circle</v-icon>
                    <span>Youth Empowerment Programs</span>
                  </div>
                  <div class="feature-item">
                    <v-icon color="#667eea" class="mr-2">mdi-check-circle</v-icon>
                    <span>Community Service Recognition</span>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="5" class="pa-6">
              <div class="hero-image-wrapper">
                <v-img
                  class="pvsa-logo"
                  :src="require(`@/assets/PVSA.png`)"
                  contain
                ></v-img>
              </div>
            </v-col>
          </v-row>
        </v-card>

        <!-- Stats Cards -->
        <v-row class="mb-6">
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-card class="modern-stats-card bronze-card" elevation="0">
              <div class="stats-card-content">
                <div class="stats-icon-wrapper bronze-icon">
                  <v-icon color="white" size="32">mdi-medal-outline</v-icon>
                </div>
                <div class="stats-info">
                  <div class="stats-label">Bronze</div>
                  <div class="stats-sublabel">Award Level</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-card class="modern-stats-card silver-card" elevation="0">
              <div class="stats-card-content">
                <div class="stats-icon-wrapper silver-icon">
                  <v-icon color="white" size="32">mdi-medal</v-icon>
                </div>
                <div class="stats-info">
                  <div class="stats-label">Silver</div>
                  <div class="stats-sublabel">Award Level</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-card class="modern-stats-card gold-card" elevation="0">
              <div class="stats-card-content">
                <div class="stats-icon-wrapper gold-icon">
                  <v-icon color="white" size="32">mdi-trophy</v-icon>
                </div>
                <div class="stats-info">
                  <div class="stats-label">Gold</div>
                  <div class="stats-sublabel">Award Level</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-card class="modern-stats-card lifetime-card" elevation="0">
              <div class="stats-card-content">
                <div class="stats-icon-wrapper lifetime-icon">
                  <v-icon color="white" size="32">mdi-star</v-icon>
                </div>
                <div class="stats-info">
                  <div class="stats-label">Lifetime</div>
                  <div class="stats-sublabel">Achievement</div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Award Categories Section -->
        <div class="modern-categories-section mb-6">
          <div class="categories-section-header">
            <div class="section-icon-badge">
              <v-icon color="white" size="24">mdi-trophy-award</v-icon>
            </div>
            <h2 class="categories-section-title">Award Categories & Criteria</h2>
          </div>

          <v-card class="modern-categories-card" elevation="0">
            <div class="categories-intro">
              <p class="intro-text">
                In 2021, We have been affiliated with "The President's Volunteer Service Award" as certifying organization.
                We recognize individuals with extraordinary service record with <strong>"The President's Volunteer Service Award"</strong>
                in the following Category and Criteria defined by PVSA.
              </p>
            </div>

            <div class="table-wrapper">
              <v-img
                class="criteria-table"
                :src="require(`@/assets/table.png`)"
                contain
              ></v-img>
            </div>
          </v-card>
        </div>

        <!-- Eligibility Section -->
        <v-card class="modern-eligibility-card" elevation="0">
          <div class="eligibility-header">
            <div class="eligibility-icon-wrapper">
              <v-icon color="white" size="36">mdi-account-check</v-icon>
            </div>
            <h2 class="eligibility-title">Honoree Eligibility</h2>
          </div>
          <div class="eligibility-content">
            <div class="eligibility-requirements">
              <div class="requirement-item">
                <div class="requirement-icon">
                  <v-icon color="#4CAF50">mdi-check-circle</v-icon>
                </div>
                <div class="requirement-text">
                  <h3 class="requirement-title">Citizenship</h3>
                  <p class="requirement-description">
                    United States citizen or lawful permanent resident of the United States (i.e., green card holder).
                  </p>
                </div>
              </div>
              <div class="requirement-item">
                <div class="requirement-icon">
                  <v-icon color="#2196F3">mdi-check-circle</v-icon>
                </div>
                <div class="requirement-text">
                  <h3 class="requirement-title">Age Requirement</h3>
                  <p class="requirement-description">
                    Must be at least five years old.
                  </p>
                </div>
              </div>
              <div class="requirement-item">
                <div class="requirement-icon">
                  <v-icon color="#FF9800">mdi-check-circle</v-icon>
                </div>
                <div class="requirement-text">
                  <h3 class="requirement-title">Service Period</h3>
                  <p class="requirement-description">
                    Completes eligible service within a 12-month period (for annual bronze, silver, and gold awards);
                    the hours for the Lifetime Award are cumulative across all years.
                  </p>
                </div>
              </div>
            </div>
            <div class="tracking-info">
              <div class="tracking-icon-wrapper">
                <v-icon color="#667eea" size="28">mdi-clock-check</v-icon>
              </div>
              <p class="tracking-text">
                Charlotte Tamil Sangam tracks service hours for the events it organizes and uses it as primary record for honoree selection.
              </p>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
* {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

/* Container */
.modern-pvsa-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
  min-height: 100vh !important;
}

/* Modern Header */
.modern-pvsa-header {
  position: relative !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  padding: 50px 24px !important;
  overflow: hidden !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
}

.header-background {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  overflow: hidden !important;
}

.header-circle {
  position: absolute !important;
  border-radius: 50% !important;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%) !important;
}

.header-circle-1 {
  width: 400px !important;
  height: 400px !important;
  top: -200px !important;
  right: -100px !important;
}

.header-circle-2 {
  width: 300px !important;
  height: 300px !important;
  bottom: -150px !important;
  left: -50px !important;
}

.header-circle-3 {
  width: 200px !important;
  height: 200px !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  opacity: 0.5 !important;
}

.header-content-wrapper {
  position: relative !important;
  z-index: 2 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 24px !important;
  flex-wrap: wrap !important;
}

.header-icon-wrapper {
  width: 80px !important;
  height: 80px !important;
  border-radius: 20px !important;
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(20px) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
}

.header-text-content {
  text-align: center !important;
}

.modern-pvsa-title {
  font-size: 42px !important;
  font-weight: 800 !important;
  color: white !important;
  margin: 0 !important;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  letter-spacing: -0.5px !important;
}

.modern-pvsa-subtitle {
  font-size: 16px !important;
  color: rgba(255, 255, 255, 0.95) !important;
  margin: 8px 0 0 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
}

/* Hero Card */
.modern-hero-card {
  border-radius: 20px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 100%) !important;
  backdrop-filter: blur(30px) !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow:
    0 16px 48px rgba(0, 0, 0, 0.15),
    0 8px 16px rgba(0, 0, 0, 0.1),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
  overflow: hidden !important;
  position: relative !important;
}

.modern-hero-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 6px !important;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%) !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.hero-content {
  display: flex !important;
  flex-direction: column !important;
  gap: 20px !important;
}

.hero-badge {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  padding: 8px 16px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  border-radius: 20px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  align-self: flex-start !important;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;
}

.hero-title {
  font-size: 32px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  margin: 0 !important;
  line-height: 1.2 !important;
}

.hero-description {
  font-size: 16px !important;
  color: #64748b !important;
  line-height: 1.7 !important;
  margin: 0 !important;
}

.hero-features {
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
  margin-top: 8px !important;
}

.feature-item {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  color: #4b5563 !important;
}

.hero-image-wrapper {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 20px !important;
}

.pvsa-logo {
  max-width: 100% !important;
  filter: drop-shadow(0 8px 24px rgba(0, 0, 0, 0.15)) !important;
}

/* Stats Cards */
.modern-stats-card {
  border-radius: 16px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 100%) !important;
  backdrop-filter: blur(30px) !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.1),
    0 4px 12px rgba(0, 0, 0, 0.06),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
}

.modern-stats-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 4px !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.bronze-card::before {
  background: linear-gradient(90deg, #CD7F32 0%, #B87333 50%, #E6A85C 100%) !important;
}

.silver-card::before {
  background: linear-gradient(90deg, #C0C0C0 0%, #A8A8A8 50%, #D8D8D8 100%) !important;
}

.gold-card::before {
  background: linear-gradient(90deg, #FFD700 0%, #FFC700 50%, #FFE55C 100%) !important;
}

.lifetime-card::before {
  background: linear-gradient(90deg, #9C27B0 0%, #7B1FA2 50%, #BA68C8 100%) !important;
}

.modern-stats-card:hover {
  transform: translateY(-8px) scale(1.03) !important;
  box-shadow:
    0 16px 40px rgba(0, 0, 0, 0.15),
    0 8px 16px rgba(0, 0, 0, 0.1),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
}

.stats-card-content {
  padding: 20px !important;
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
}

.stats-icon-wrapper {
  width: 56px !important;
  height: 56px !important;
  border-radius: 14px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.15),
    inset 0 1px 2px rgba(255, 255, 255, 0.3) !important;
  position: relative !important;
  overflow: hidden !important;
  flex-shrink: 0 !important;
}

.stats-icon-wrapper::before {
  content: '' !important;
  position: absolute !important;
  top: -50% !important;
  left: -50% !important;
  width: 200% !important;
  height: 200% !important;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.3), transparent) !important;
  transform: rotate(45deg) !important;
  animation: shimmer 3s infinite !important;
}

.bronze-icon {
  background: linear-gradient(135deg, #CD7F32 0%, #B87333 100%) !important;
}

.silver-icon {
  background: linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%) !important;
}

.gold-icon {
  background: linear-gradient(135deg, #FFD700 0%, #FFC700 100%) !important;
}

.lifetime-icon {
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%) !important;
}

.stats-info {
  flex: 1 !important;
}

.stats-label {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  line-height: 1.2 !important;
  margin-bottom: 4px !important;
}

.stats-sublabel {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #64748b !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

/* Categories Section */
.modern-categories-section {
  margin-bottom: 32px !important;
}

.categories-section-header {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
  margin-bottom: 24px !important;
  padding: 0 8px !important;
}

.section-icon-badge {
  width: 48px !important;
  height: 48px !important;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 4px 12px rgba(102, 126, 234, 0.4),
    inset 0 1px 2px rgba(255, 255, 255, 0.3) !important;
}

.categories-section-title {
  font-size: 28px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  margin: 0 !important;
}

.modern-categories-card {
  border-radius: 18px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 100%) !important;
  backdrop-filter: blur(30px) !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow:
    0 12px 32px rgba(0, 0, 0, 0.12),
    0 4px 12px rgba(0, 0, 0, 0.08),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
  overflow: hidden !important;
  position: relative !important;
}

.modern-categories-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 5px !important;
  background: linear-gradient(90deg, #FFD700 0%, #FFC700 50%, #FFE55C 100%) !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.categories-intro {
  padding: 32px 32px 24px 32px !important;
}

.intro-text {
  font-size: 16px !important;
  color: #4b5563 !important;
  line-height: 1.7 !important;
  margin: 0 !important;
}

.table-wrapper {
  padding: 0 32px 32px 32px !important;
  display: flex !important;
  justify-content: center !important;
}

.criteria-table {
  max-width: 100% !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
}

/* Eligibility Card */
.modern-eligibility-card {
  border-radius: 18px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 100%) !important;
  backdrop-filter: blur(30px) !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow:
    0 12px 32px rgba(0, 0, 0, 0.12),
    0 4px 12px rgba(0, 0, 0, 0.08),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
  overflow: hidden !important;
  position: relative !important;
}

.modern-eligibility-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 5px !important;
  background: linear-gradient(90deg, #4CAF50 0%, #388E3C 50%, #81C784 100%) !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.eligibility-header {
  padding: 32px 32px 16px 32px !important;
  display: flex !important;
  align-items: center !important;
  gap: 20px !important;
}

.eligibility-icon-wrapper {
  width: 72px !important;
  height: 72px !important;
  border-radius: 16px !important;
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 8px 20px rgba(76, 175, 80, 0.4),
    inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
  flex-shrink: 0 !important;
}

.eligibility-title {
  font-size: 28px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  margin: 0 !important;
  line-height: 1.2 !important;
}

.eligibility-content {
  padding: 16px 32px 32px 32px !important;
}

.eligibility-requirements {
  display: flex !important;
  flex-direction: column !important;
  gap: 20px !important;
  margin-bottom: 24px !important;
}

.requirement-item {
  display: flex !important;
  gap: 16px !important;
  padding: 20px !important;
  background: rgba(255, 255, 255, 0.6) !important;
  border-radius: 12px !important;
  border-left: 4px solid transparent !important;
  transition: all 0.3s ease !important;
}

.requirement-item:nth-child(1) {
  border-left-color: #4CAF50 !important;
}

.requirement-item:nth-child(2) {
  border-left-color: #2196F3 !important;
}

.requirement-item:nth-child(3) {
  border-left-color: #FF9800 !important;
}

.requirement-item:hover {
  background: rgba(255, 255, 255, 0.9) !important;
  transform: translateX(4px) !important;
}

.requirement-icon {
  flex-shrink: 0 !important;
  display: flex !important;
  align-items: flex-start !important;
  padding-top: 2px !important;
}

.requirement-text {
  flex: 1 !important;
}

.requirement-title {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  margin: 0 0 8px 0 !important;
  line-height: 1.2 !important;
}

.requirement-description {
  font-size: 15px !important;
  color: #64748b !important;
  line-height: 1.6 !important;
  margin: 0 !important;
}

.tracking-info {
  padding: 20px !important;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%) !important;
  border-radius: 12px !important;
  border: 2px solid rgba(102, 126, 234, 0.2) !important;
  display: flex !important;
  gap: 16px !important;
  align-items: center !important;
}

.tracking-icon-wrapper {
  flex-shrink: 0 !important;
  width: 56px !important;
  height: 56px !important;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 4px 12px rgba(102, 126, 234, 0.3),
    inset 0 1px 2px rgba(255, 255, 255, 0.3) !important;
}

.tracking-text {
  font-size: 15px !important;
  font-weight: 600 !important;
  color: #4b5563 !important;
  line-height: 1.6 !important;
  margin: 0 !important;
}

/* Animations */
@keyframes gradientFlow {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .modern-pvsa-title {
    font-size: 36px !important;
  }

  .modern-pvsa-subtitle {
    font-size: 14px !important;
  }

  .hero-title {
    font-size: 28px !important;
  }

  .hero-description {
    font-size: 15px !important;
  }

  .categories-section-title,
  .eligibility-title {
    font-size: 24px !important;
  }

  .categories-intro,
  .eligibility-header,
  .eligibility-content {
    padding: 24px !important;
  }

  .table-wrapper {
    padding: 0 24px 24px 24px !important;
  }
}

@media (max-width: 600px) {
  .modern-pvsa-header {
    padding: 40px 16px !important;
  }

  .header-icon-wrapper {
    width: 64px !important;
    height: 64px !important;
  }

  .modern-pvsa-title {
    font-size: 28px !important;
  }

  .modern-pvsa-subtitle {
    font-size: 13px !important;
  }

  .hero-badge {
    font-size: 12px !important;
    padding: 6px 12px !important;
  }

  .hero-title {
    font-size: 24px !important;
  }

  .hero-description {
    font-size: 14px !important;
  }

  .feature-item {
    font-size: 14px !important;
  }

  .stats-card-content {
    padding: 16px !important;
  }

  .stats-icon-wrapper {
    width: 48px !important;
    height: 48px !important;
  }

  .stats-label {
    font-size: 16px !important;
  }

  .stats-sublabel {
    font-size: 11px !important;
  }

  .categories-section-title,
  .eligibility-title {
    font-size: 20px !important;
  }

  .section-icon-badge {
    width: 40px !important;
    height: 40px !important;
  }

  .categories-intro,
  .eligibility-content {
    padding: 20px !important;
  }

  .eligibility-header {
    flex-direction: column !important;
    text-align: center !important;
    padding: 20px !important;
  }

  .eligibility-icon-wrapper {
    width: 64px !important;
    height: 64px !important;
  }

  .intro-text {
    font-size: 14px !important;
  }

  .table-wrapper {
    padding: 0 20px 20px 20px !important;
  }

  .requirement-item {
    flex-direction: column !important;
    padding: 16px !important;
  }

  .requirement-title {
    font-size: 16px !important;
  }

  .requirement-description {
    font-size: 14px !important;
  }

  .tracking-info {
    flex-direction: column !important;
    text-align: center !important;
    padding: 16px !important;
  }

  .tracking-icon-wrapper {
    width: 48px !important;
    height: 48px !important;
  }

  .tracking-text {
    font-size: 14px !important;
  }
}
</style>
